import angular from 'angular';
import NumberConversionService from './number-converter.service';

export default angular.module('autoboard.converter', [NumberConversionService])
  .name;